import { Component, OnInit } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, Params } from "@angular/router";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { FeedbackService } from "src/app/Services/feedback.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.css"],
  providers: [FeedbackService],
})
export class ContactComponent implements OnInit {
  title = "ITARIUM Technologies India Pvt. Ltd. | Contact Us";
  displayLocationTab: boolean = false;
  id: any;
  feedbackFormGroup: FormGroup;
  FeedbackData: any;
  constructor(
    private titleService: Title,
    private _snackBar: MatSnackBar,
    private feedbackService: FeedbackService,
    private meta: Meta,
    private activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.meta.addTags([
      {
        name: "keywords",
        content:
          "BMC, BMC Softwares, BMC Tools, Itarium Technologies, BMC, IT Support, Technology, Pune, IT Companies, Karvenagar",
      },
      {
        name: "description",
        content:
          "ITARIUM works with many organizations to provide better IT solutions as per their requirements.",
      },
      { name: "robots", content: "index, follow" },
    ]);
    window.scrollTo(0, 0);
    this.activatedRoute.paramMap.subscribe((params: Params) => {
      this.id = params.get("id");
      console.log("ID", this.id);
      if (this.id === "Location") {
        this.displayLocationTab = true;
        window.scrollTo(480, 480);
      }
    });
    this.feedbackFormGroup = this._formBuilder.group({
      name: [null, Validators.required],
      email: [
        null,
        Validators.compose([Validators.required, , this.validateInput]),
      ],
      emailSubject: [null, ""],
      message: [null, Validators.required],
    });
    // Date: [null, Validators.required],
    // Car:[null,Validators.required],
    // Name:[null,Validators.required],
    // Mobile:[null,Validators.required],
    // Address: [null, Validators.required],
    // Email: [null, Validators.required],
    // Notes:[null]

    //   matcher = new MyErrorStateMatcher();
    //   export class InputErrorStateMatcherExample {
    //     emailFormControl = new FormControl('', [
    //       Validators.required,
    //       Validators.email,
    //     ]);
    //     matcher = new MyErrorStateMatcher();
    //   }
  }
  validateInput(c: FormControl) {
    let NIC_REGEX_NEW =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // Regular Expression 2

    return NIC_REGEX_NEW.test(c.value)
      ? null
      : {
          validateInput: {
            valid: false,
          },
        };
  }
  sendEmail() {
    console.log("this.FeedbackData", this.feedbackFormGroup.valid);
    if (this.feedbackFormGroup.valid) {
      this._snackBar.open(
        "Thank you. Your message has been sent successfully.",
        "Close",
        {
          duration: 2000,
          verticalPosition: "top",
        }
      );
      this.FeedbackData = this.feedbackFormGroup.getRawValue();
      console.log("this.FeedbackData", this.FeedbackData);
      this.feedbackService
        .sendFeedback(this.FeedbackData)
        .subscribe((result) => {});
      this.feedbackFormGroup = this._formBuilder.group({
        name: [""],
        email: [""],
        emailSubject: [""],
        message: [""],
      });
    }
  }
}
